module.exports = "<survey-editor survey-id='surveyId' action-type='actionType'></survey-editor>\n";